var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhoto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25.768 25.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.442,171.221A3.221,3.221,0,1,1,171.221,168,3.221,3.221,0,0,1,174.442,171.221Zm0,0",
    transform: "translate(-158.337 -158.337)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.057,129.492,98.684,128H92.961l-.373,1.492a.46.46,0,0,1-.446.348H88v8.283h15.645v-8.283H99.5A.46.46,0,0,1,99.057,129.492Zm-3.235,8.171a4.141,4.141,0,1,1,4.141-4.141A4.141,4.141,0,0,1,95.822,137.663Zm0,0",
    transform: "translate(-82.938 -120.638)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.884,0A12.884,12.884,0,1,0,25.768,12.884,12.884,12.884,0,0,0,12.884,0Zm8.743,17.946a.46.46,0,0,1-.46.46H4.6a.46.46,0,0,1-.46-.46v-9.2a.46.46,0,0,1,.46-.46H8.844L9.217,6.79a.46.46,0,0,1,.446-.348h6.442a.46.46,0,0,1,.446.348l.373,1.492h4.242a.46.46,0,0,1,.46.46Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoto);
export default __webpack_public_path__ + "static/media/icon-photo.d000c1f849f1a1aec03d6bdf9390305e.svg";
export { ForwardRef as ReactComponent };